<div tabindex="0" role="banner" aria-label="Emergency Banner" class="emergency-banner" *ngIf="showEmergencyBanner && isEmergencyBanner">
  <div class="container-constraint">
    <!--desktop view start-->
    <div class="row visible-lg visible-md hidden-sm hidden-xs">
      <div *ngIf="emergencyText" class="col-lg-10 col-md-9">
          <div [attr.aria-label]="emergencyText" role="alert" class="alert-tittle">
              <img alt="alert-icon" src="../../../../assets/images/emergency-banner/alert-icon-lg.png/"> 
          <p aria-hidden="true">{{emergencyText | truncate: 100:'...': true }}</p>
        </div>
      </div>
      <div class="col-lg-2 col-md-3">
         <span (click)="close()" class="close-icon"></span>
        <button *ngIf="buttonText" class="btn banner-btn pull-right" (click)="navigateTo()">{{buttonText}}</button>
      </div>
    </div>
    <!--desktop view end-->
    <!--mobile view code start -->
    <div class="hidden-lg hidden-md visible-sm visible-xs pad-rgt-17">
      <div *ngIf="emergencyText" class="col-sm-12 col-xs-12 pad-xs-0">
          <div class="alert-tittle">
            <img alt="Emergency banner alert icon" src="../../../../assets/images/emergency-banner/alert-icon-xs.png/">
            <p>{{emergencyText | truncate: 68:'...': true }}
              <span *ngIf="buttonText" (click)="navigateTo()">{{buttonText}}</span>
            </p>
          </div>
        <span (click)="close()" class="close-icon"></span>
      </div>
    </div>
    <!--mobile view code end -->
  </div>
</div>
